<div class="page-title">
  <h1><ng-content></ng-content></h1>
</div>
